export default __webpack_public_path__ + "static/logo-b63e82744002ca467a3a59847e531699.png";